// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__2Jp6q","signatureButtonsRight":"ModalSign_signatureButtonsRight__g9M6e"};